import { Navigate, Outlet, useLocation } from 'react-router';
import { useSystemStatus } from './api';

export function SystemStatusGate() {
  const location = useLocation();
  const { data } = useSystemStatus();

  const onSetup = location.pathname === '/setup';
  if (data && !data.bootstrapped && !onSetup) {
    return <Navigate to="/setup" replace />;
  }
  if (data && data.bootstrapped && onSetup) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}
